import Header from "@components/Header";
import PageBody from "@components/PageBody";
import Footer from "@components/Footer";
import styles from "./index.module.css";
import { Button, Container, Stack, Text } from "@mantine/core";
import { Paths } from "@app/paths";
import { Link } from "react-router-dom";
import FormTextInput from "@/components/StyledTextInput/FormTextInput";
import useIntl from "@/infrastructure/hooks/useIntl";
import useSignIn from "./useSignIn";

function SignIn() {
  const t = useIntl();
  const { handleSubmit, control } = useSignIn();

  return (
    <>
      <Header />
      <PageBody column>
        <Container size="md" className={styles.container}>
          <form onSubmit={handleSubmit}>
            <Stack align="stretch" justify="center">
              <h1 className={styles.title}>{t("signIn.signInTitle")}</h1>
              <FormTextInput
                control={control}
                name="email"
                label={t("signIn.emailLabel")}
                size="md"
              />
              <FormTextInput
                control={control}
                name="password"
                label={t("signIn.passwordLabel")}
                size="md"
              />
              <Text ta="right" size="sm">
                <Link to={Paths.ForgotPassword} replace>
                  {t("signIn.forgotPasswordLink")}
                </Link>
              </Text>

              <Button size="md" type="submit">
                {t("signIn.signInButtonTitle")}
              </Button>
              {/* <Divider label="Or" labelPosition="center" />
              <Button size="md">Sign in with Google</Button> */}

              <Text ta="center" size="sm" mt="md">
                {t("signIn.dontHaveAnAccountText")}
                <Text td="underline" fw={600}>
                  <Link to={Paths.SignUp} replace>
                    {t("signIn.signUpHereLink")}
                  </Link>
                </Text>
              </Text>
            </Stack>
          </form>
        </Container>
      </PageBody>
      <Footer />
    </>
  );
}

export default SignIn;
